module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  require('jquery-timeentry/jquery.timeentry.css'); 
    ; __append("\r\n")
    ;  require('jquery-timeentry/jquery.plugin.min.js'); 
    ; __append("\r\n")
    ;  require('jquery-timeentry/jquery.timeentry.min.js'); 
    ; __append("\r\n")
    ;  var u = require('util/Util.js').default;

var timeValue = gridData[selectedRowId].attributes.specific;
var bHasSeconds = u.isTrue(gridData[selectedRowId].attributes.hasSeconds);
var bShowEmpty = u.isTrue(gridData[selectedRowId].attributes.showEmpty);
var bIs24HourClock = u.isTrue(gridData[selectedRowId].attributes.is24HourClock);

if (bShowEmpty) {
    timeValue = '';
} else {
    timeValue = u.getTime(timeValue, {use24Hour: bIs24HourClock, useSeconds: bHasSeconds})
}

    ; __append("\r\n\r\n<div class=\"prop-header\"><span class=\"prop-label\">Time</span></div>\r\n<div class=\"row prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <input type=\"radio\" name=\"timeValueType\" checked=\"checked\" value=\"Empty\" />\r\n            Empty\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <input type=\"radio\" name=\"timeValueType\" value=\"Now\" />\r\n            Now\r\n        </div>\r\n    </div>\r\n   \r\n    <div class=\"row\">  \r\n        <div class=\"col-md-4 prop-sublabel form-group-flex prop-separator-radio\" style=\"width: 70px; padding-top: 8px !important;\">\r\n            <input type=\"radio\" name=\"timeValueType\" value=\"Specific\" style=\"margin-top: 0px;margin-right: 2px;\"/>\r\n            Specific\r\n        </div>\r\n        <div class=\"col-md-8 nopadding-r\">\r\n            <input type=\"text\" size=\"10\" draggable=\"false\" disabled=\"disabled\" name=\"timeValueSpecific\" id=\"timeValueSpecific\" style=\"width:100px;\" value=\"")
    ; __append(escapeFn( timeValue))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <input type=\"checkbox\" name=\"is24HourClock\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.is24HourClock))
    ; __append(" />\r\n            24 Hour Clock\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <input type=\"checkbox\" name=\"hasSeconds\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.hasSeconds))
    ; __append(" />\r\n            Show Seconds\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}